var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconInstagram = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.21,0H82.79A82.88,82.88,0,0,0,0,82.79V217.21A82.88,82.88,0,0,0,82.79,300H217.21A82.88,82.88,0,0,0,300,217.21V82.79A82.88,82.88,0,0,0,217.21,0Zm56.17,217.21a56.24,56.24,0,0,1-56.17,56.17H82.79a56.24,56.24,0,0,1-56.17-56.17V82.79A56.24,56.24,0,0,1,82.79,26.62H217.21a56.24,56.24,0,0,1,56.17,56.17V217.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,72.7A77.3,77.3,0,1,0,227.3,150,77.39,77.39,0,0,0,150,72.7Zm0,128A50.68,50.68,0,1,1,200.68,150,50.73,50.73,0,0,1,150,200.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.54,50.13a19.51,19.51,0,1,0,13.81,5.72A19.59,19.59,0,0,0,230.54,50.13Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-instagram.eaad7772.svg";
export { ForwardRef as ReactComponent };